module.exports = __webpack_public_path__ + "img/tank-undefined.f3715621.png";